import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import s from './WidthContainer.scss'


const WidthContainer = forwardRef(({ children, className, id, inline, narrow, style, contentCenter, role, dataTestId, ariaLabel }, ref) => {
  const rootClassName = cx(s.container, className, {
    [s.narrow]: narrow,
    [s.wide]: !narrow,
    [s.inline]: inline,
    [s.contentCenter]: contentCenter,
  })

  return (
    <div
      id={id}
      className={rootClassName}
      ref={ref}
      style={style}
      role={role}
      data-testid={dataTestId}
      aria-label={ariaLabel}
    >
      {children}
    </div>
  )
})

WidthContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  narrow: PropTypes.bool,
  contentCenter: PropTypes.bool,
  inline: PropTypes.bool, // it's useful when u need horizontal paddings on mobile for scrollable content with items
  role: PropTypes.string,
  id: PropTypes.string,
  dataTestId: PropTypes.string,
  ariaLabel: PropTypes.string,
}


export default WidthContainer
